define('models/toc',[
  "globals",
  "backbone",
  "fancytree",
  "URIjs"
], function (globals, Backbone, fancytree, URI) {
  "use strict";

  return Backbone.Model.extend({
    initialize: function () {
      _.bindAll(this, "filterTree");
      globals.content.on("change:filter", this.filterTree);
      if(window.innerWidth > 768 &&  $("#navpane").hasClass("in") === false) {
        $("#collapseTOC").trigger("click");
      }
    },

    filterTree: function () {
      var filter = globals.content.get("filter"),
        tree = $("#tree").fancytree("getTree");

      if (!_.isEmpty(filter)) {
        tree.applyFilter(function (node) {
          if (!_.has(node.data, "metadata")) return false;
          return _.every(_.map(_.keys(filter), function (m) {
            if (_.has(node.data.metadata, m)) {
              return _.some(filter[m], function (v) {
                return v === node.data.metadata[m];
              });
            } else {
              return false;
            }
          }));
        });

        // Filter extension hides non-matching child nodes.
        // Manually hide all non-matching libraries
        $("#tree.fancytree-ext-filter .fancytree-container > li")
          .each(function () {
            $(this).toggle($(this).has(".fancytree-match").length);
          });
      } else {
        tree.clearFilter();
      }
    },

    tocActivate: function (event, data) {

      if ($("#toc").hasClass("active")) {
        var node = data.node;

        if (_.has(node.data, "href")) {
          _.each(node.tree.getSelectedNodes(), function (s) {
            s.setSelected(false);
          });
          node.setExpanded(true).done(function () {
            node.setActive(true);
          });
          setTimeout(function () {
              if (URI(node.data.location.path).is("relative")) {
                globals.content.set("location", node.data.location);
                if(window.innerWidth < 768 &&  $("#navpane").hasClass("in") === true) {
                  $("#collapseTOC").trigger("click");
                  $(".content-pane").addClass("col-xs-12")
                  $(".content-pane").removeClass("hidden-xs")
                  $("#mobileCover").removeClass("col-xs-12")
                  $("#mobileCover").addClass("hidden-xs")
                }
              } else {
                window.open(node.data.location.path, "_blank");
              }               
            
              if (document.getElementById("comment-form") == null) return;
              document.getElementById("comment-form").reset();
              $(document.getElementById("comment-form")).hide();
              $(document.getElementById("highlight")).show();
              $(document.getElementById("attach-form")).hide();
            }, 0);
        }
      }
    }
  });
});

